import { useEffect, useState } from "react";
import { adminApi, errMsg } from "@/lib/api";
import { AdminProvider } from "./AdminContext";
import { AdminLayout } from "./AdminLayout";
import { Login } from "./Login";

export default function AdminApp() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    document.title = "Website Admin";
    if (!localStorage.getItem("admin_token")) { setUser(false); return; }
    adminApi.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("admin_token"); setUser(false); });
  }, []);

  const logout = async () => {
    try { await adminApi.post("/auth/logout"); } catch (e) { errMsg(e); }
    localStorage.removeItem("admin_token");
    setUser(false);
  };

  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-sky-50"><div className="h-10 w-10 animate-spin rounded-full border-4 border-sky-200 border-t-blue-900" /></div>;
  if (!user) return <Login onLogin={setUser} />;
  return (
    <AdminProvider onLogout={logout}>
      <AdminLayout />
    </AdminProvider>
  );
}
